import RecentActivities from "./recentActivities";
import ConsumeGraph from "./consumeTransactionsGraph"
import TransactionsKpis from "./kpis";
const TransactionsGraph = () => {
    const renderCharts = () => {
        return (
            <div className="mt-7 grid lg:grid-cols-2 gap-x-5 max-sm:overflow-auto">
                <h3 className='text-lg font-medium text-subTextColor mb-1.5 hidden md:block'>Cards Consume</h3>
                <h3 className='text-lg font-medium text-subTextColor mb-1.5 hidden md:block'>Activity</h3>
                <div className="border bg-chartimg !border-cardBorder rounded-md p-4 drop-shadow-sm bg-blueimg mb-7 md:mb-0">
                    <div className="kpi-section-style h-full barchart-section cards-Consume-chart mb-6">
                        <h3 className='text-lg font-medium text-subTextColor mb-1.5 md:hidden block'>Cards Consume</h3>
                        <ConsumeGraph />
                    </div>
                </div>
                <div className="border bg-chartimg !border-cardBorder rounded-md p-4 drop-shadow-sm bg-blueimg mb-7 md:mb-0">
                    <div className="kpi-section-style h-full barchart-section cards-Consume-chart mb-6">
                        <h3 className='text-lg font-medium text-subTextColor mb-1.5 md:hidden block'>Cards Consume</h3>
                        <RecentActivities />
                    </div>
                </div>
            </div>
        );
    };
    return (
        <div className="">
            <TransactionsKpis />
            {renderCharts()}
        </div>
    );
};
export default TransactionsGraph;
